/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D%0A._23rrnH0rAS%7Btransition%3Abox-shadow%20.2s%20ease-in-out%2Ctransform%20.2s%20ease-in-out%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._4ouGXIPIoL%7Bmin-width%3A220px%7D%0A._1EqgXlsz7G%7Bmax-width%3A20pc%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._1SdfoHYbGa%7Btransition%3Anone%7D%7D%0A._3X9j4qseFd%7B-webkit-mask-image%3Aurl(%22data%3Aimage%2Fsvg%2Bxml%2C%253Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'38'%20height%3D'6'%253E%253Crect%20width%3D'38'%20height%3D'6'%20rx%3D'3'%2F%253E%253C%2Fsvg%253E%22)%2Clinear-gradient(%23000%2C%23000)%3Bmask-image%3Aurl(%22data%3Aimage%2Fsvg%2Bxml%2C%253Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'38'%20height%3D'6'%253E%253Crect%20width%3D'38'%20height%3D'6'%20rx%3D'3'%2F%253E%253C%2Fsvg%253E%22)%2Clinear-gradient(%23000%2C%23000)%7D%0A._45s7WmbMq5%7B-webkit-mask-size%3A38px%206px%2C100%25%20100%25%3Bmask-size%3A38px%206px%2C100%25%20100%25%7D%0A._4AZChJnPJF%7B-webkit-mask-position%3Acenter%20var(--ds-space-100%2C8px)%2Ccenter%3Bmask-position%3Acenter%20var(--ds-space-100%2C8px)%2Ccenter%7D%0A._3mXABNXSSG%7B-webkit-mask-repeat%3Ano-repeat%2Crepeat%3Bmask-repeat%3Ano-repeat%2Crepeat%7D%0A._0A6Iyfk2L1%7B-webkit-mask-composite%3Axor%3Bmask-composite%3Aexclude%7D%0A._2Y5PIXHgVH%7B-webkit-mask-clip%3Ano-clip%3Bmask-clip%3Ano-clip%7D%0A._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2I62gz2ADO%7Binset-block-start%3Avar(--ds-space-100%2C8px)%7D%0A._3iC0zd715P%7Binset-inline-start%3A50%25%7D%0A._1VJPcajssS%7Btransform%3AtranslateX(-50%25)%7D%0A._39xV02R4us%7Bwidth%3A38px%7D%0A._0jFU0VZimw%7Bheight%3A6px%7D%0A._2OUyjtKPGx%7Bbox-shadow%3Ainset%200%201px%202px%20var(--ds-border%2C%230b120e24)%7D%0A._1pp6NdYbGa%7Bpointer-events%3Anone%7D%0A._3fSdSTGk8v%3Ahover%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D%0A._3NJLv8TCo3%3Ahover%7Btransform%3AtranslateY(-1px)%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._4eGeXtYbGa%3Ahover%7Btransform%3Anone%7D%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._1ZB6UyPgdg%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D%0A._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._42Yu6BgtVO%7Bz-index%3A100%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._0wOv4Q18ZR%7Bcursor%3Adefault%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._0KLXruqi9L%7Bbackground-color%3Avar(--ds-surface-raised%2C%23fff)%7D%0A._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._2iEGP20MSB%7Bgrid-template-columns%3Aminmax(0%2C1fr)%20auto%7D%0A._0ca6V792QF%7Bgrid-template-rows%3Aauto%201fr%20auto%7D%0A._3NN0tOO1EA%7Bgrid-template-areas%3A%22cover%20cover%22%20%22content%20content%22%20%22footer%20metadata%22%7D%0A._42d1HA8HPE%7Brow-gap%3Avar(--ds-space-150%2C9pt)%7D%0A._0hPCNLF05b%7Balign-items%3Aend%7D%0A._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D%0A._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D%0A._0LQT5E5zaO%7Bpadding-inline-start%3Avar(--ds-space-200%2C1pc)%7D%0A._03SyCP5zaO%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
















































import React from 'react';
import { cx } from '@atlaskit/css';
import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import type { CardProps } from '../../types';
import { Card as LegacyCard } from './Legacy/Card';
const styles = {
  card: "_0bjKvDyzSk _23rrnH0rAS _1mT5xdRAKS _0jFU0VN91d _4ouGXIPIoL _1EqgXlsz7G _1SdfoHYbGa",
  frame: "_1mT5xdRAKS _0jFU0VN91d",
  cutout: "_3X9j4qseFd _45s7WmbMq5 _4AZChJnPJF _3mXABNXSSG _0A6Iyfk2L1 _2Y5PIXHgVH",
  cutoutShadow: "_0bjKvDS5Zs _1mT5xdWVPG _2I62gz2ADO _3iC0zd715P _1VJPcajssS _39xV02R4us _0jFU0VZimw _2OUyjtKPGx _1pp6NdYbGa",
  interactive: "_3fSdSTGk8v _3NJLv8TCo3 _4eGeXtYbGa",
  pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6BgtVO _0KLXrujOvk",
  disabledPressable: "_0wOv4Q18ZR",
  surface: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0KLXruqi9L _3iDTPbgBM8 _2iEGP20MSB _0ca6V792QF _3NN0tOO1EA _42d1HA8HPE _0hPCNLF05b _0jFU0VN91d _46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO"
};
export const Card = ({
  xcss,
  hasCutout = false,
  ...props
}: CardProps & {
  hasCutout?: boolean;
}): React.JSX.Element => {
  if (!expVal('jira_browse_agent_modal_update', 'isEnabled', false)) {
    return <LegacyCard {...props} xcss={xcss} />;
  }
  const {
    children,
    ariaLabel,
    'aria-describedby': ariaDescribedBy,
    onClick,
    isDisabled = false,
    testId,
    ...boxProps
  } = props;
  return <Box {...boxProps} xcss={cx(styles.card, Boolean(onClick) && !isDisabled && styles.interactive, xcss)} testId={testId}>
			<Box xcss={cx(styles.frame, hasCutout && styles.cutout)}>
				{onClick ? <Pressable xcss={cx(styles.pressable, isDisabled && styles.disabledPressable)} onClick={() => onClick()} aria-label={ariaLabel} aria-describedby={ariaDescribedBy} isDisabled={isDisabled} data-card-pressable /> : null}
				<Box xcss={styles.surface} data-card-surface>
					{children}
				</Box>
			</Box>
			{hasCutout ? <Box xcss={styles.cutoutShadow} aria-hidden="true" /> : null}
		</Box>;
};